import BlogArticlePage from '../components/BlogArticles';
import { publicMeta } from './public-meta';

export const meta = publicMeta(
  'Introducing Swing Choreo | Cartwheel',
  'A motion model for whole performances: chained actions, hands, faces, and multiple people from one prompt.',
);

export default BlogArticlePage;
